// @flow
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import { withRouter } from 'app/context/Router';
import type { Location } from 'lib/ReactRouterTypes';
import { redirectByClassCode } from 'lib/ClientRouteLogic';

type Props = {
  params: { groupCode: string },
  router: *,
};

class GroupViewIndex extends React.Component<Props, void> {
  componentDidMount() {
    return redirectByClassCode(
      this.props.params.groupCode,
      CurrentUser.getUser(),
      CurrentUser.getUserId(),
      this.props.router.location,
      (location: Location) => {
        this.props.router.replace({
          pathname: location.pathname,
          query: this.props.router.location.query,
        });
      }
    );
  }

  render() {
    return null;
  }
}

export { GroupViewIndex };
export default withRouter(GroupViewIndex);
